import { Component, inject, Injector, OnInit } from '@angular/core';
import { DialogBaseComponent } from '../../base-admin-panel/dialog-base/dialog-base.component';
import { CompaniesService, CompanyModel, ICompanyCreateModel, IExternalAPIViewModel } from "../../../../services/companies.service";
import { map, switchMap, tap } from 'rxjs';
import { SettingsService, TimezoneViewModel } from 'app/services/settings.service';
import {UserViewModel} from "../../../../services/users.service";

@Component({
    selector: 'app-companies-dialog-base',
    templateUrl: './companies-dialog-base.component.html',
    styleUrls: ['./companies-dialog-base.component.css'],
    standalone: false
})
export class CompaniesDialogBaseComponent<T extends ICompanyCreateModel> extends DialogBaseComponent<T> implements OnInit {
  public companies: CompanyModel[] = [];
  public externalAPI: IExternalAPIViewModel;
  public timezones: TimezoneViewModel[] = [];
  public currentCompany: CompanyModel;
  private companiesService: CompaniesService;
  private currentUser: UserViewModel;

  public openedTabName: string = "companyData";
  private settingsService: SettingsService = inject(SettingsService);
  protected showParentCompanyField: boolean = true;

  constructor(protected injector: Injector) {
    super(injector);
    this.externalAPI = {
      telegramSettings: {
        token: "",
        enabled: false
      },
      emailSettings: {
        smtpHost: "",
        smtpPort: 0,
        ssl: false,
        user: "",
        from: "",
        password: "",
        text: "",
        enabled: false
      },
      companyId: 0
    };
    this.companiesService = injector.get(CompaniesService);
  }

  public openTab(name: string) {
    this.openedTabName = name;
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  protected isValid(): boolean {
    if (this.model.ParentCompanyId == undefined) {
      this.toastr.error(this.translate.instant("Parent company required"));
      return;
    }


    return true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.currentUser = this.usersService.getCurrentUser();
    let id = (this.model as { Id?: number })?.Id ?? 0;

    this.settingsService.getTimezones().subscribe(res => {
      this.timezones = res;
      if (this.model.TimeZone == "")
        this.model.TimeZone = this.timezones.find(tz => tz.Offset === 0).Name;
    });
    this.companiesService.getCompanies().subscribe(res => {
      if (id)
        this.companies = res.filter(x => x.Id != id);
      else
        this.companies = res;
    });

    if (id > 0) {
      this.companiesService.getCompany(id).pipe(
        tap(company => {
          this.model = company as any;
          this.currentCompany = company as CompanyModel;
        }),
        switchMap(company =>
          this.companiesService.getExternalAPIsByCompanyId(id).pipe(
            map(externalAPI => ({ company, externalAPI }))
          )
        )
      ).subscribe(({ externalAPI: res }) => {
        if (res) {
          if (res.emailSettings) this.externalAPI.emailSettings = res.emailSettings;
          if (res.telegramSettings) this.externalAPI.telegramSettings = res.telegramSettings;
          this.externalAPI.companyId = res.companyId;
        }
      });
    }
  }
}

